import { BROADCAST_SET_ATTENDEE_MUTE_STATUS } from '@shoflo/studio-redux/actions/attendee/types';

/**
 * Thunk action creator to set the mute status for the local attendee.
 *
 * This only dispatches the BROADCAST_SET_ATTENDEE_MUTE_STATUS action if the
 * provided attendeeId matches the current (local) attendee in meeting state.
 * All other attendee IDs are ignored (no-op) to prevent unintended state changes.
 * This is because Presenter unlike Director Pro/Lite only manages mute status for the local user.
 *
 * @param {string} attendeeId - The ID of the attendee whose mute status is being updated.
 * @param {boolean} isMuted - Whether the attendee should be marked as muted.
 * @returns {Function} A thunk function: (dispatch, getState) => void
 * @example
 * dispatch(setAttendeeMuteStatus('attendee-123', true));
 */
function setAttendeeMuteStatus(attendeeId, isMuted) {
  return (dispatch, getState) => {
    const {
      meeting: { attendeeId: localAttendeeId }
    } = getState();
    if (attendeeId !== localAttendeeId) return;

    const action = {
      type: BROADCAST_SET_ATTENDEE_MUTE_STATUS,
      payload: {
        attendeeId,
        isMuted
      }
    };

    dispatch(action);
  };
}

export default setAttendeeMuteStatus;
